// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
// TODO: This is a hack to make swig includes work
let ParagraphQuestionEditor
const QuestionEditor = require("./question-editor").default

export default ParagraphQuestionEditor = (function () {
  ParagraphQuestionEditor = class ParagraphQuestionEditor extends (
    require("lib/static-shim").default(QuestionEditor)
  ) {
    static initClass() {
      this.prototype.template = require("./templates/paragraph-question.html")

      this.prototype.ui = {
        addAnswerExplanation: ".add-answer-explanation",
        answerExplanation: ".answer-explanation-container"
      }

      this.prototype.triggers = {
        "click @ui.addAnswerExplanation": "show:answer:explanation"
      }
    }

    onRender() {
      if (this.model.get("wrong_answer_tip")) {
        return this.onShowAnswerExplanation()
      }
    }

    onShowAnswerExplanation() {
      this.ui.addAnswerExplanation.hide()
      return this.ui.answerExplanation.show()
    }
  }
  ParagraphQuestionEditor.initClass()
  return ParagraphQuestionEditor
})()
